export default "__VITE_ASSET__ruMQNR3E__"